module.exports = __webpack_public_path__ + "assets/images/alert.bf70e9d4aee6c118dc65274b3cd4f281.svg";